module.exports = __webpack_public_path__ + "static/img/no9.430a9d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no9.png
// module id = XdU9
// module chunks = 31